import { useState, useCallback } from "react";
import { putWitnessOrderURL } from "../../utils/ConstantsURL";

export const useUpdateWitnessOrder = (token) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateWitnessOrder = useCallback(
    async (witnessId, newOrder, synthesisId) => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(putWitnessOrderURL(), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            witnessId: Number(witnessId),
            newOrder: Number(newOrder),
            synthesisId: Number(synthesisId),
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || `Error ${response.status}`);
        }

        return { success: true, message: data.message };
      } catch (err) {
        console.error("useUpdateWitnessOrder:", err.message);
        setError(err.message);
        return { success: false, message: err.message };
      } finally {
        setLoading(false);
      }
    },
    [token],
  );

  return { updateWitnessOrder, loading, error };
};
